import {blockClassesConcat} from 'bem-components-connector'
import logo from "@common-images/logo.svg";


export const Logo = ({
                             className = '',
                             progressSibling = false
                     }) => {
        let blockClasses = blockClassesConcat('logo', {progressSibling}, className)

        return (<div className={blockClasses}>
                <img src={logo} />
        </div>)
}